import React, { useContext, useEffect, useState, useRef } from 'react';
import { Input, RadioGroup, Checkbox } from '@progress/kendo-react-inputs';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { Button } from '@progress/kendo-react-buttons';
import DeleteFormItem from '../../DeleteFormItem';
import { LocalizationContext } from '../../../contexts';
import Uploader, { uploaderTypes } from '../../Uploader';
import PublishSwitch from '../publishSwitch';
import './index.scss';
import '../forms.scss';

export default function GeneralBanner({ data, onUpdate, validator, settingsData = {}, ...rest }) {
  const emptyItem = useRef({ name: "", must: false, title: "", image: "", image_mobile: "", animate_json: "", animate_json_mobile: "", link: "", link_target: "_top", isPublish: false });
  const generalEmptyItem = useRef({ ...emptyItem.current });
  const personalEmptyItem = useRef({ ...emptyItem.current });
  const [compData, setCompData] = useState({});
  //const [validateMode, setValidateMode] = useState(false);
  const [contentSelect, setContentSelect] = useState(0);
  const [localization] = useContext(LocalizationContext);
  const { labels } = localization;
  const bannerType = settingsData.type || ['general'];

  validator.current = () => {
    return true;
  };

  useEffect(() => {
    const defaultData = { general: [{ ...generalEmptyItem.current }], personal: [{ ...personalEmptyItem.current }] };
    const startCompData = { ...defaultData, ...JSON.parse(JSON.stringify(data ? data : {})) };
    if (!startCompData.general || startCompData.general.length === 0) {
      startCompData.general = [{ ...generalEmptyItem.current }];
    }
    if (!startCompData.personal || startCompData.personal.length === 0) {
      startCompData.personal = [{ ...personalEmptyItem.current }];
    }
    setCompData(startCompData);
  }, [data]);

  const handleContentSelect = (e) => {
    setContentSelect(e.selected);
  }

  const handleDeleteClick = (itemIdToDelete, type) => {
    const newCompData = { ...compData };
    if (newCompData[type].length > 1) {
      newCompData[type].splice(itemIdToDelete, 1);
    } else {
      if (type === 'general') {
        newCompData[type] = [{ ...generalEmptyItem.current }]
      } else {
        newCompData[type] = [{ ...personalEmptyItem.current }]
      }
    }
    setCompData(newCompData);
    onUpdate(newCompData);
  };

  const handleAddClick = (type) => {
    const newCompData = { ...compData };
    if (type === 'general') {
      newCompData[type] = [...compData[type], { ...generalEmptyItem.current }];
    } else {
      newCompData[type] = [...compData[type], { ...personalEmptyItem.current }];
    }
    setCompData(newCompData);
  };

  const updateItem = (type, i, newData) => {
    const newCompData = { ...compData };
    newCompData[type][i] = { ...compData[type][i], ...newData };
    setCompData(newCompData);
    onUpdate(newCompData);
  }

  const isNotOneEmptyItem = (type) => {
    return (compData[type].length !== 1 || JSON.stringify(compData[type][0]) !== JSON.stringify(type === "general" ? generalEmptyItem.current : personalEmptyItem.current));
  }

  const showRequired = (type, item, requiredField) => {
    let noRequiredField;
    if (requiredField.length > 1) {
      noRequiredField = (!item[requiredField[0]] && !item[requiredField[1]]) || (item[requiredField[0]] && item[requiredField[1]])
    } else {
      noRequiredField = !item[requiredField[0]];
    }

    return (isNotOneEmptyItem(type) && noRequiredField)
  }

  // const validateForm = () => {
  //   const emptyGeneralItem = compData?.general?.length === 1 && JSON.stringify(compData.general[0]) === JSON.stringify(generalEmptyItem.current);
  //   const emptyPersonalItem = compData?.personal?.length === 1 && JSON.stringify(compData.personal[0]) === JSON.stringify(personalEmptyItem.current);
  //   if (emptyGeneralItem && emptyPersonalItem) {
  //     setValidateMode(false);
  //   } else {
  //     const formNotValidGeneral = !emptyGeneralItem && compData.general.some(item => !item.title || (!item.image && !item.animate_json) || (item.image && item.animate_json) || (!item.image_mobile && !item.animate_json_mobile) || (item.image_mobile && item.animate_json_mobile));
  //     const formNotValidPersonal = !emptyPersonalItem && compData.personal.some(item => !item.title || (!item.image && !item.animate_json) || (item.image && item.animate_json) || (!item.image_mobile && !item.animate_json_mobile) || (item.image_mobile && item.animate_json_mobile));
  //     if (formNotValidGeneral || formNotValidPersonal) {
  //       setValidateMode(true);
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  const canPublish = (item) => {
    if (!item.title ||
      !(item.image_mobile || item.animate_json_mobile) ||
      !(item.image || item.animate_json)) {
      return false;
    }
    return true;
  };

  const showComponent = (tab) => {
    return <div className="form-content">
      <div className="form-items">
        {compData[tab]?.map((item, i) => {
          return (
            <React.Fragment key={i}>
              <div className="form-item">
                <div className="form-item__title">
                  {labels.pagesManagement.forms.item} {i + 1} : {item.name}
                  {isNotOneEmptyItem(tab) && <DeleteFormItem itemIdToDelete={i} type={tab} handleDeleteClick={handleDeleteClick} />}
                </div>
                <div className="form-field">
                  <label className="form-field__label">{labels.pagesManagement.forms.add_name} ({labels.pagesManagement.forms.wont_be_in_site})</label>
                  <Input name={'name'} value={item.name} onChange={({ value }) => updateItem(tab, i, { name: value })}></Input>
                </div>
                <div className="form-field">
                  <label className="form-field__label inline tooltip">
                    <Tooltip anchorElement="target" position="bottom">
                      <span title={labels.pagesManagement.forms.status_must}>{labels.pagesManagement.forms.status}</span>
                    </Tooltip>
                  </label>
                  <Checkbox label={labels.pagesManagement.forms.must}
                    layout='horizontal'
                    value={item.must}
                    checked={item.must}
                    onChange={(event) => {
                      updateItem(tab, i, { must: event.value });
                    }}
                  />
                </div>
                <div className="form-field">
                  <label className="form-field__label">{labels.pagesManagement.forms.add_pc_banner}</label>
                  <Uploader type={uploaderTypes.image} imageUrl={item.image} prefix={'generalBanner'} onChange={(file) => { updateItem(tab, i, { image: file }) }} />
                </div>
                <div className="form-field separator"><label className="form-field__label">{labels.pagesManagement.forms.or}</label></div>
                <div className="form-field">
                  <label className="form-field__label">{labels.pagesManagement.forms.add_pc_animation}</label>
                  <Uploader type={uploaderTypes.animation} animationUrl={item.animate_json} prefix={'generalBanner'} onChange={(file) => { updateItem(tab, i, { animate_json: file }) }} />
                  {showRequired(tab, item, ['image', 'animate_json']) && <div className="form-field__required">{labels.pagesManagement.forms.required_image_or_animation}</div>}
                </div>
                <div className="form-field">
                  <label className="form-field__label">{labels.pagesManagement.forms.add_mobile_banner}</label>
                  <Uploader type={uploaderTypes.image} imageUrl={item.image_mobile} prefix={'generalBanner'} onChange={(file) => { updateItem(tab, i, { image_mobile: file }) }} />
                </div>
                <div className="form-field separator"><label className="form-field__label">{labels.pagesManagement.forms.or}</label></div>
                <div className="form-field">
                  <label className="form-field__label">{labels.pagesManagement.forms.add_mobile_animation}</label>
                  <Uploader type={uploaderTypes.animation} animationUrl={item.animate_json_mobile} prefix={'generalBanner'} onChange={(file) => { updateItem(tab, i, { animate_json_mobile: file }) }} />
                  {showRequired(tab, item, ['image_mobile', 'animate_json_mobile']) && <div className="form-field__required">{labels.pagesManagement.forms.required_image_or_animation}</div>}
                </div>
                <div className="form-field">
                  <label className="form-field__label">{labels.pagesManagement.forms.add_link}</label>
                  <Input name={'link'} value={item.link} onChange={({ value }) => updateItem(tab, i, { link: value })}></Input>
                  <RadioGroup data={[
                    { label: labels.pagesManagement.forms.open_top, value: '_top' },
                    { label: `${labels.pagesManagement.forms.open_blank} (${labels.pagesManagement.forms.for_external_links})`, value: '_blank' }
                  ]}
                    layout='horizontal'
                    value={item.link_target}
                    onChange={({ value }) => {
                      updateItem(tab, i, { link_target: value });
                    }}
                  />
                </div>
                <div className="form-field">
                  <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_accessibility_title} ({labels.pagesManagement.forms.banner_short_description})</label>
                  <Input name={'title'} value={item.title} onChange={({ value }) => updateItem(tab, i, { title: value })}></Input>
                  {showRequired(tab, item, ['title']) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
                </div>
                <PublishSwitch isPublish={item?.isPublish} canPublish={canPublish(item)}
                  updateItem={(event) => updateItem(tab, i, { isPublish: event.target.value })} />
              </div>
              {compData[tab].length - 1 === i && <div className="form-add"><Button primary={true} onClick={() => { handleAddClick(tab); }}>{labels.pagesManagement.forms.add_item}</Button></div>}
            </React.Fragment>)
        })}
      </div>
    </div>
  }

  return (
    <React.Fragment>
      <div className="form-message">
        {labels.pagesManagement.menu.home.general_banner}
      </div>
      <div className="form-content">
        <div className="form-tabs">
          {/* <TabStrip selected={contentSelect} onSelect={handleContentSelect} animation={false}>
            {bannerType.map((tab, i) => {
              return <TabStripTab key={i} title={`${labels.pagesManagement.forms.banner} - ${labels.pagesManagement.forms[tab.split('_')[0]]}`}></TabStripTab>;
            })}
          </TabStrip> */}
          {bannerType.map((tab, i) => {
            return <div key={i} className={`form-inner ${contentSelect === i ? "form-inner--active" : ""}`} data-tab={i}>
              {showComponent(tab)}
            </div>
          })}
        </div>
        {/* <div style={{ marginTop: 20 }}>{JSON.stringify(compData)}</div> */}
      </div>
    </React.Fragment>
  );
};